/* @flow */

import * as React from 'react';
import type {FieldProps} from 'redux-form';
import {DateTimeInput} from 'shells/date-time-picker';

export function DateTime(props: FieldProps) {
    const {input, ...rest} = props;

    // Wrap DateTimeInput in extra div to preserve proper styling
    return (
        <div>
            <DateTimeInput
                {...input}
                {...rest}
                ref={(c) => {
                    // $FlowFixMe upgrading Flow to v0.92.1 on web
                    if (typeof props.getFieldRef === 'function') props.getFieldRef(c);
                }}
            />
        </div>
    );
}
